<template>
  <div class="home_about">
    <div class="gsjj">
      <p class="p1">解决方案</p>
      <div class="fg"></div>
    </div>
    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="index" @click="item.url && openUrl(item.url)" :class="{ clickable: !!item.url }">
        <div class="left">
          <img :src="item.imgUrl" alt="" />
        </div>
        <div class="right">
          <div class="title">{{ item.title }}</div>
          <div class="content">{{ item.content }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import itemList from "../text/index";
export default {
  components: {},
  props: {},
  data() {
    return {
      list: [],
    };
  },
  methods: {
    openUrl(url) {
      window.open(url, '_blank');
    },
  },
  mounted() {
    this.list = itemList();
  },
};
</script>

<style lang="scss" scoped>
.home_about {
  background: linear-gradient(to bottom, #f4f5f8, #fbfbfc);
  // padding-top: 0.5rem;
  // background-color: #f10065;
}
.gsjj {
  width: 208px;
  height: 99px;
  // background-color: #073875;
  margin: 0 auto;
  padding-top: 83px;
  // margin-top: 100px;
  margin-bottom: 80px;
}
.fg {
  width: 165px;
  height: 5px;
  background: #0a41ff;
  border-radius: 0px 0px 0px 0px;
  margin: 47px 21px 0px 22px;
}
.p1 {
  width: 208px;
  height: 52px;
  font-size: 52px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  background-color: rgba(255, 255, 255, 0);

  line-height: 93px;
  // -webkit-background-clip: text;
  // -webkit-text-fill-color: transparent;
}
.list {
  margin: 0 150px;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  .item {
    width: 100%;
    height: 270px;
    background: #fff;
    margin-bottom: 40px;
    display: flex;
    div {
      height: 100%;
    }
    .left {
      width: 460px;
      // background-color: red;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .right {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 30px;
      .title {
        font-size: 36px;
        margin-top: 45px;
        font-weight: bold;
        line-height: 40px;
        height: 40px;
      }
      .content {
        font-size: 24px;
        font-weight: 400;
        line-height: 26px;
        margin: 20px 0;
      }
    }
  }
  .item:hover {
    box-shadow: 0 5px 5px 0 #f4f5f8;
  }
  .item.clickable {
    cursor: pointer;
  }
  .item.clickable:hover {
    box-shadow: 0 5px 15px 0 rgba(10, 65, 255, 0.15);
  }
}
</style>